import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const FAQS = [
  {
    q: 'How fast can you start?',
    a: 'Most engagements kick off within 5–7 business days of contract sign. Discovery happens in week one; design or build starts in week two.',
  },
  {
    q: 'Do you work with startups or just enterprises?',
    a: 'Both. We have engagement tiers built for early-stage founders, growing teams, and enterprises running complex digital transformations.',
  },
  {
    q: 'Where is your team based?',
    a: 'We operate as a distributed senior team across multiple time zones, which means there\'s always someone on the wheel. Sync hours are agreed per project.',
  },
  {
    q: 'Can you take over an existing project?',
    a: 'Yes. We frequently rescue stalled builds, refactor legacy systems, and migrate from underperforming agencies. Audit comes first, plan comes second.',
  },
  {
    q: 'Do you offer ongoing maintenance?',
    a: 'Absolutely. Our Growth tier is explicitly designed for ongoing iteration, optimization, and scale. Launch tier projects include 30 days of post-launch support.',
  },
  {
    q: 'How do you handle IP and contracts?',
    a: 'You own everything we produce — code, designs, and content. Standard MSA + SOW model with clear deliverables, milestones, and exit clauses.',
  },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-40 px-6 lg:px-12 border-t border-white/10 bg-brand-surface/30">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-1.5 h-1.5 bg-brand-primary" />
            <span className="font-manrope text-xs uppercase tracking-[0.3em] text-white/60">
            06 &mdash; Questions
            </span>
          </div>
          <h2 className="font-outfit font-black tracking-tighter text-white text-5xl lg:text-7xl leading-[0.9]">
            Frequently<br />asked.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger className="font-outfit text-lg lg:text-2xl text-white text-left tracking-tight hover:no-underline py-6 hover:text-brand-primary transition-colors">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="font-manrope text-base text-white/65 leading-relaxed pb-6 pr-8">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
